import React from 'react';

import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import MediaServicesPreselectedIcon from '@atlaskit/icon/glyph/media-services/preselected';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

interface TodoItemProps {
	isChecked: boolean;
	description: string;
}

export const TodoItem = ({ isChecked, description }: TodoItemProps) => {
	const { formatMessage } = useIntl();
	return (
		<Inline space="space.075" alignBlock="start">
			<Box xcss={iconWrapperStyles}>
				{isChecked ? (
					<CheckCircleIcon
						label={formatMessage(messages.doneNonFinal)}
						primaryColor={token('color.icon.success', colors.G300)}
						size="small"
					/>
				) : (
					<MediaServicesPreselectedIcon
						label={formatMessage(messages.todoNonFinal)}
						primaryColor={token('color.background.accent.gray.subtler.hovered', colors.N40)}
						size="small"
					/>
				)}
			</Box>
			<Box as="span" xcss={descriptionStyles}>
				{description}
			</Box>
		</Inline>
	);
};

const descriptionStyles = xcss({
	color: 'color.text.subtlest',
	lineHeight: '24px',
});

const iconWrapperStyles = xcss({
	display: 'flex',
	flexShrink: 0,
	height: '24px',
	width: '24px',
	justifyContent: 'center',
	alignItems: 'center',
});
